<template>
  <div
    class="form-title-element-wrapper d-flex align-items-center justify-content-center gap-2"
  >
    <div
      v-if="element?.settings?.prefixIcon?.icon"
      class="prefix-image-wrap overflow-hidden bg-transparent d-flex align-items-center justify-content-center"
    >
      <img
        :id="`prefix-icon-${element.id}`"
        class="prefix-icon object-fit-contain mh-100 mw-100"
        :src="element.settings.prefixIcon.icon"
      />
    </div>
    <h1
      :style="titleStyle"
      :id="`title-${element.id}`"
      class="form-title display-1 w-100 bg-transparent m-0 p-0 d-flex align-items-end justify-content-start"
    >
      {{ element.label }}
    </h1>
  </div>
</template>

<script>
export default {
  name: 'FormTitleElement',
  props: {
    element: {
      type: Object,
      required: true,
    },
    titleStyle: { type: Object, default: () => {} },
  },
};
</script>

<style scoped>
.form-title-element-wrapper {
  margin-bottom: -2px;
}

.form-title-element-wrapper .prefix-image-wrap {
  width: 50px;
  height: 50px;
}

.form-title-element-wrapper .prefix-image-wrap img.prefix-icon {
  -webkit-user-drag: none;
}
.form-title-element-wrapper .form-title {
  font-weight: 900;
  font-family: 'Avenir Next', sans-serif;
  letter-spacing: -0.02em;
  color: #000000;
  vertical-align: middle;
  cursor: default;
  word-break: break-word;
}
.form-field-card.editable .form-field .form-title-element-wrapper .form-title {
  height: unset;
}

.form-title-element-wrapper .display-1 {
  font-size: 45px;
}
@media only screen and (max-width: 767px) {
  .form-title-element-wrapper .form-title {
    letter-spacing: -0.01em;
  }
}
</style>
